import { fetcher } from '@commenda/utils';
import { CreateEnvelopeRequest } from './types';

export async function createEnvelope(
  data: CreateEnvelopeRequest
): Promise<Response> {
  return fetcher('e-signature/envelopes', {
    method: 'POST',
    body: data,
  });
}
